import { AgreementsStorageService } from './agreements-storage.service';
import { AgreementStorageDataModel } from './agreement-storage-data.model';
import { AgreementBasicModel } from './agreement-basic.model';
import { IAgreement } from '../../interfaces/agreements.interface';

export class AgreementItemModel extends AgreementBasicModel {
  protected groupDataInstance: AgreementStorageDataModel;

  public omsCode: string;
  public description: string;
  public moreDescription: string;
  public type: string;
  public discountEnabling: boolean;
  public groupId: number;
  public index: number;

  constructor(
    agreement: IAgreement,
    groupId: number,
    storage: AgreementsStorageService,
    agreementIndex: number,
  ) {
    super(storage);

    this.omsCode = agreement.omsCode;
    this.name = agreement.name;
    this.moreDescription = agreement.moreDescription;
    this.required = agreement.required;
    this.type = agreement.type;
    this.selected = agreement.selected;
    this.priority = agreement.priority;
    this.discountEnabling = agreement.discountEnabling;
    this.groupId = groupId;
    this.index = agreementIndex;

    this.groupDataInstance = this.storage.getGroupById(this.groupId);
    this.prepareDescription(agreement);
  }

  private prepareDescription(agreement: IAgreement): void {
    const description = agreement.description;
    this.description = description;

    if (this.required) {
      this.description = `<span class="sr-only checkprop">Pole wyboru odznaczone</span>${description}<span class="required-mark">*</span>`;
    }
  }
}
